import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const MessageListSkeleton = () => {
    return (
        <div>
            {[...Array(5)].map((_, index) => (
                <div key={index} className="flex justify-between items-center p-4 border-b border-gray-100">
                    <div className="flex items-center gap-3 flex-1">
                        <Skeleton circle width={44} height={44} />
                        <div className="flex-1">
                            <Skeleton width={96} height={16} className="mb-2" />
                            <Skeleton width={128} height={12} />
                        </div>
                    </div>
                    <div className="flex flex-col items-end">
                        <Skeleton width={48} height={12} className="mb-1" />
                        <Skeleton circle width={20} height={20} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export const MessageBubbleSkeleton = () => {
    return (
        <div className="space-y-4 px-4">
            {[...Array(6)].map((_, index) => {
                const isSender = index % 2 === 0;

                return (
                    <div
                        key={index}
                        className={`flex ${isSender ? 'justify-end' : 'justify-start'}`}
                    >
                        <div
                            className={`rounded-2xl px-4 py-3 space-y-2 ${isSender ? 'bg-gray-100' : 'bg-gray-50'
                                }`}
                            style={{
                                width: isSender ? '30%' : '40%',
                            }}
                        >
                            <Skeleton width="100%" height={16} />
                            {isSender ? (
                                <Skeleton width={40} height={16} className="ml-auto" />
                            ) : (
                                <Skeleton width={40} height={16} />
                            )}

                            {index === 3 && (
                                <Skeleton width="100%" height={160} className="rounded-xl" />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export const HeaderSkeleton = () => {
    return (
        <div className="p-4 border-b border-gray-200">
            <div className="flex items-center gap-2">
                <Skeleton circle width={48} height={48} />
                <div>
                    <Skeleton width={96} height={16} className="mb-1" />
                    <Skeleton width={64} height={12} />
                </div>
            </div>
        </div>
    );
};

export const SearchSkeleton = () => {
    return (
        <div className="p-4">
            <Skeleton width={80} height={16} className="mb-4" />
            <Skeleton width="100%" height={40} className="rounded-lg" />
        </div>
    );
};

export const InputSkeleton = () => {
    return (
        <div className="p-3 border-t border-gray-200">
            <div className="flex items-center gap-2">
                <Skeleton circle width={32} height={32} />
                <div className='w-full rounded-full'>
                    <Skeleton width="100%" height={40} className="rounded-full" />
                </div>
                <Skeleton circle width={32} height={32} />
            </div>
        </div>
    );
};

export const MessagesSkeleton = () => {
    return (
        <div className="bg-white rounded-lg p-1 shadow-sm h-[calc(100vh-110px)] flex flex-col">
            <div className="h-full flex">
                <div className="w-full lg:w-[28%] border-r border-gray-200 flex flex-col">
                    <SearchSkeleton />
                    <div className="flex-1 overflow-y-auto">
                        <MessageListSkeleton />
                    </div>
                </div>

                <div className="hidden lg:flex flex-1 flex-col">
                    <HeaderSkeleton />
                    <div className="flex-1 overflow-y-auto p-4">
                        <MessageBubbleSkeleton />
                    </div>
                    <InputSkeleton />
                </div>
            </div>
        </div>
    );
};

export const SubscriptionPlanSkeleton = () => {
    return (
        <div className="mt-6 space-y-4 h-[40vh] overflow-y-auto custom-scrollbar">
            {[...Array(3)].map((_, index) => (
                <div
                    key={index}
                    className="relative flex items-center p-4 py-6 rounded-xl border-2 border-gray-200 bg-white"
                >
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                            <Skeleton width={60} height={20} />
                            <Skeleton width={80} height={16} />
                        </div>
                        <Skeleton width={120} height={14} />
                    </div>
                    <div className="flex items-center gap-2">
                        <Skeleton circle width={20} height={20} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MessagesSkeleton; 